import dayjs from "dayjs";
import axios from "../../config/axiosConfig";
import {
  BANK_RECO_LEDGER_REPORT_REQUEST,
  BANK_RECO_LEDGER_REPORT_FAILURE,
  BANK_RECO_LEDGER_BY_PARTY_REPORT_FAILURE,
  SET_BANK_RECO_LEDGER_PARTIES,
  SET_BANK_RECO_LEDGER_BY_PARTY,
  BANK_RECO_LEDGER_BY_PARTY_REPORT_REQUEST,
  UPDATE_BANK_RECO_LEDGER_STATUS_REQUEST,
  UPDATE_BANK_RECO_LEDGER_STATUS,
  UPDATE_BANK_RECO_LEDGER_STATUS_FAILURE,
  UPDATE_BANK_RECO_LEDGER_DATE_REQUEST,
  UPDATE_BANK_RECO_LEDGER_DATE,
  UPDATE_BANK_RECO_LEDGER_DATE_FAILURE,
  SET_BANK_RECO_LEDGER_BY_SCHEDULE,
  BANK_RECO_LEDGER_REPORT_SCHEDULE_REQUEST

} from "../types/bank-reco-ledger-report-types";

export const getBankRecoLedgerPartyList = (params) => {
  return async (dispatch, getState) => {
    try {
      // dispatch({ type: BANK_RECO_LEDGER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        finStartDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        fromDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        toDate: dayjs(auth.finyear?.To_Date)?.format('YYYY-MM-DD'),
        commanMaster: auth.company?.Common_Master
      };    
      const requestParams = { ...defaultParams, ...params };

      const queryString = new URLSearchParams(requestParams).toString();
      // const fullUrl = `/bank-reconciliation-report/getPartyList?${queryString}`;
      // const fullUrlWithTotal = `/bank-reconciliation-report/getPartyListWithTotal?${queryString}`;
      const fullUrlWithTotal = `/ledger-report/getBankRecoPartyListWithTotal?${queryString}`;

      // console.log('API Request URL: ', fullUrl);
      // axios.get(fullUrl).then((response) => {
      //   console.log('API Response Data-1: ', response);
      //   if (response.data) {
      //     dispatch({ type: SET_BANK_RECO_LEDGER_PARTIES, payload: response.data });
      //   }
      // }).catch((error) => {
      //   console.error("Error fetching Ledger Parties:", error);
      //   dispatch({ type: BANK_RECO_LEDGER_REPORT_FAILURE, error: error.message });
      // });
      
      // axios.get(fullUrlWithTotal).then((res) => {
      //   console.log('API Response Data-2: ', res);
      //   if (res.data) {
      //     dispatch({ type: SET_BANK_RECO_LEDGER_PARTIES, payload: res.data });
      //   }
      // }).catch((error) => {
      //   console.error("Error fetching Ledger Parties With Total:", error);
      //   dispatch({ type: BANK_RECO_LEDGER_REPORT_FAILURE, error: error.message });
      // });
      return axios.get(fullUrlWithTotal).then((res) => {
        return res;
      }).catch((error) => {
        dispatch({ type: BANK_RECO_LEDGER_REPORT_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error("Error fetching Ledger Parties:", error);
      dispatch({ type: BANK_RECO_LEDGER_REPORT_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getBankRecoLedgerDataByParty = (params) => {
  return (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECO_LEDGER_BY_PARTY_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        finStartDate: auth.finyear?.From_Date,
        commanMaster: auth.company?.Common_Master
      };
      console.log('params', params);
    
      const requestParams = {
        ...defaultParams,
        ...params,
        fromDate: params.fromDate,
        toDate: params.toDate,
        accountId: params.accountId,
      };

      const queryString = new URLSearchParams(requestParams).toString();
      // const fullUrl = `/bank-reconciliation-report/getLedgerByParty?${queryString}`;
      const fullUrl = `/ledger-report/getBankRecoByParty?${queryString}`;

      console.log('API Request URL: ', fullUrl);
      axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: SET_BANK_RECO_LEDGER_BY_PARTY, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Ledger Report by Party:", error);
        dispatch({ type: BANK_RECO_LEDGER_BY_PARTY_REPORT_FAILURE, error: error.message });
      });  

    } catch (error) {
      console.error("Error fetching Ledger Report by Party:", error);
      dispatch({ type: BANK_RECO_LEDGER_BY_PARTY_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getBankRecoLedgerData = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECO_LEDGER_REPORT_SCHEDULE_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        finStartDate: auth.finyear?.From_Date,
        commanMaster: auth.company?.Common_Master
      };
      console.log('params', params);
    
      const requestParams = {
        ...defaultParams,
        ...params,
        fromDate: params.fromDate,
        toDate: params.toDate,
      };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/bank-reconciliation-report/getLedgerData?${queryString}`;

      console.log('API Request URL: ', fullUrl);
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: SET_BANK_RECO_LEDGER_BY_SCHEDULE, payload: response.data });
          console.log('response>>', response);
          
          return response;
        }
      }).catch((error) => {
        console.error("Error fetching Ledger Report by Party:", error);
        dispatch({ type: BANK_RECO_LEDGER_REPORT_FAILURE, error: error.message });
      });  

    } catch (error) {
      console.error("Error fetching Ledger Report by Party:", error);
      dispatch({ type: BANK_RECO_LEDGER_REPORT_FAILURE, error: error.message });
    }
  };
};


export const updateBankRecoLedgerStatus = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_BANK_RECO_LEDGER_STATUS_REQUEST });

      const { refId, refType, isChecked } = params;

      if (!refId || !refType) {
        console.error("refId & refType required");
        return;
      }

      const queryString = new URLSearchParams({
        refId,
        refType
      }).toString();

      const fullUrl = `/bank-reconciliation-report/updateLedgerStatus?${queryString}`;

      console.log("API Request URL:", fullUrl);

      // 🔥 Send PUT request with body
      const response = await axios.put(fullUrl, { isChecked });

      console.log("API Response:", response.data);

      dispatch({
        type: UPDATE_BANK_RECO_LEDGER_STATUS,
        payload: response.data
      });

    } catch (error) {
      console.error("Error updating ledger status:", error);
      dispatch({
        type: UPDATE_BANK_RECO_LEDGER_STATUS_FAILURE,
        error: error.message
      });
    }
  };
};

export const updateBankRecoLedgerRecoDate = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_BANK_RECO_LEDGER_DATE_REQUEST });

      const { refId, refType, reco_date } = params;

      if (!refId || !refType) {
        console.error("refId & refType required");
        return;
      }

      const queryString = new URLSearchParams({
        refId,
        refType
      }).toString();

      const fullUrl = `/bank-reconciliation-report/updateLedgerRecoDate?${queryString}`;

      console.log("API Request URL:", fullUrl);

      // 🔥 Send PUT request with body
      const response = await axios.put(fullUrl, { reco_date });

      console.log("API Response:", response.data);

      dispatch({
        type: UPDATE_BANK_RECO_LEDGER_DATE,
        payload: response.data
      });

    } catch (error) {
      console.error("Error updating ledger status:", error);
      dispatch({
        type: UPDATE_BANK_RECO_LEDGER_DATE_FAILURE,
        error: error.message
      });
    }
  };
};

export const clearBankRecoLedgerDataByParty = () => {
  return async (dispatch) => {
    dispatch({ type: SET_BANK_RECO_LEDGER_BY_PARTY, payload: {} });
  }
}
